<template>
  <div>
    <span class="font-normal cursor-pointer" @click="openModal()">View Milestones</span>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Lead Milestones
        </h1>
        <div>
          <div v-if="milestones" class="bg-white overflow-hidden w-full mb-6">
            <div class="text-gray-600 w-full flex items-center justify-between align-middle">
              <div class="w-full">
                <!-- <MilestoneItem v-model="form.pre_approved" :lead="lead" :milestone="pre_approved" label="PreApprovedM" class="w-full" /> -->
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full pr-4">
                      <span class="font-bold">Application</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.application_taken" type="date" class="w-full" @change="update('application_taken', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('application_taken', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">Pre-Approved</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.pre_approved" type="date" class="w-full" @change="update('pre_approved', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('pre_approved', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">Processing</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.processing_date" type="date" class="w-full" @change="update('processing_date', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('processing_date', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">Disclosures</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.registered" type="date" class="w-full" @change="update('registered', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('registered', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">Submitted</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.underwriting_submitted" type="date" class="w-full" @change="update('underwriting_submitted', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('underwriting_submitted', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">Appraisal Requested</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.appraisal_requested" type="date" class="w-full" @change="update('appraisal_requested', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('appraisal_requested', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">Appraisal Received</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.appraisal_received" type="date" class="w-full" @change="update('appraisal_received', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('appraisal_received', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">Approved</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.underwriting_approved" type="date" class="w-full" @change="update('underwriting_approved', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('underwriting_approved', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">CTC</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.clear_to_close" type="date" class="w-full" @change="update('clear_to_close', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('clear_to_close', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                    <div class="w-full">
                      <span class="font-bold">Closed</span>
                    </div>
                    <div class="flex flex-column text-center">
                      <text-input v-model="form.closed" type="date" class="w-full" @change="update('closed', $event.target.value)" />
                      <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="update('closed', '')">
                        <i class="ml-2 fas fa-times text-red-500" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import TextInput from '@/Shared/TextInput'
import moment from 'moment'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    TextInput,
  },
  props: {
    milestones: {
      type: Object,
      default: null,
    },
    lead: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: router.form({
        application_taken: moment(this.milestones.application_taken).format('YYYY-MM-DD'),
        pre_approved: moment(this.milestones.pre_approved).format('YYYY-MM-DD'),
        processing_date: moment(this.milestones.processing).format('YYYY-MM-DD'),
        registered: moment(this.milestones.registered).format('YYYY-MM-DD'),
        underwriting_submitted: moment(this.milestones.underwriting_submitted).format('YYYY-MM-DD'),
        appraisal_requested: moment(this.milestones.appraisal_requested).format('YYYY-MM-DD'),
        appraisal_received: moment(this.milestones.appraisal_received).format('YYYY-MM-DD'),
        underwriting_approved: moment(this.milestones.underwriting_approved).format('YYYY-MM-DD'),
        clear_to_close: moment(this.milestones.clear_to_close).format('YYYY-MM-DD'),
        closed: moment(this.milestones.closed).format('YYYY-MM-DD'),
      }),
    }
  },
  methods: {
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    datestamp : function (date) {
      return moment(date).format('MM/DD/YY')
    },
    update(fieldName, date) {

      if(!date){
        this.form[fieldName] = null
      }

      fieldName = (fieldName === 'processing_date') ? 'processing' : fieldName

      // this.form.fieldName = moment(date).format('YYYY-MM-DD')
      router.post('/milestone', {
        id: this.lead.id,
        fieldName: fieldName,
        date: date,
      },
      {
        onSuccess: () => {
          console.log('Milestone Updated!')
        },
        only: ['milestones'], preserveScroll: true,
      })
    },
    // deleteMilestone(fieldName) {
    //   // router.delete(this.route('notes.destroy', id, { only: ['notes'] }))
    //   router.delete('/milestone',{
    //     id: this.lead.id,
    //     fieldName: fieldName,
    //   },{ only: ['milestones'], preserveScroll: true })
    //   // Inertia.delete('/notes/'+id,{ only: ['notes'] })
    // },
  },
}
</script>
